// 폰트 사이즈(반응형) 관련 유틸.
// RN 앱의 사용자 설정(medium/large/xlarge)에 맞춰 document.documentElement에
// size-{key} 클래스를 부여하면, index.css에 정의된 CSS 변수(--font-size-*)와
// tailwind.config.js의 fontSize 매핑을 통해 text-12/14/16/17/18/20/22 등
// 기존 Tailwind 클래스가 자동으로 반응형 크기를 갖게 된다.

export const SIZE_MEDIUM = "medium";
export const SIZE_LARGE = "large";
export const SIZE_XLARGE = "xlarge";

export const VALID_SIZES = [SIZE_MEDIUM, SIZE_LARGE, SIZE_XLARGE];

/**
 * document.documentElement에 size-{size} 클래스를 부여한다.
 * 기존에 부여돼 있던 size-* 클래스는 모두 제거한 뒤 새로 부여한다.
 *
 * @param {string} size - "medium" | "large" | "xlarge" (그 외 값은 무효 처리)
 * @param {{ fallback?: string }} [options]
 *   - fallback: size가 유효하지 않을 때 대신 적용할 값.
 *     생략하면(undefined) size가 유효하지 않은 경우 아무 것도 하지 않는다(무시).
 */
export const applySizeClass = (size, { fallback } = {}) => {
  const resolvedSize = VALID_SIZES.includes(size) ? size : fallback;

  if (!VALID_SIZES.includes(resolvedSize)) return;

  VALID_SIZES.forEach((validSize) => {
    document.documentElement.classList.remove(`size-${validSize}`);
  });
  document.documentElement.classList.add(`size-${resolvedSize}`);
};
